export const PROJECT_ID = 'PROJECT_ID';
export const PROJECT_URL = 'PROJECT_URL';
export const PROJECT_INIT = 'PROJECT_INIT';
